module.exports = __webpack_public_path__ + "static/media/refresh.98524c8e.svg";